import { render, staticRenderFns } from "./topNumber.vue?vue&type=template&id=7fcf74cc&scoped=true"
import script from "./topNumber.vue?vue&type=script&lang=js"
export * from "./topNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcf74cc",
  null
  
)

export default component.exports